import { render } from "./RegTeamOnEvent.vue?vue&type=template&id=6a9c3fbd&scoped=true"
import script from "./RegTeamOnEvent.vue?vue&type=script&lang=js"
export * from "./RegTeamOnEvent.vue?vue&type=script&lang=js"

import "./RegTeamOnEvent.vue?vue&type=style&index=0&id=6a9c3fbd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9c3fbd"]])

export default __exports__